define('modules/profiles/notifications/profile.notifications.controllers',[
    "client"
], function(
    Prospector)
{
    Prospector.module("AsyncApp.Notification", function(Notification, Prospector, Backbone, Marionette, $, _){
        Notification.Controller = {
            showMonitoringRolesNotification:function(options){
                require(["modules/profiles/notifications/views/monitoring.roles.notifications.view"],
                function(MonitoringRolesNotificationView){
                    var view = new MonitoringRolesNotificationView(options);
                    $('#snackbar-container').append(view.render().el);
                });
            }
        }
    });
    return Prospector.AsyncApp.Notification.Controller;
});
